import { render, staticRenderFns } from "./TwoFactorModal.vue?vue&type=template&id=667f716c&scoped=true&"
import script from "./TwoFactorModal.vue?vue&type=script&lang=js&"
export * from "./TwoFactorModal.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorModal.vue?vue&type=style&index=0&id=667f716c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667f716c",
  null
  
)

export default component.exports